<template lang="pug">
.session-manager
		modal(v-if="sessionState === 'expiresSoon' && showSessionExpiresSoonModal && !isRefreshingSession"  @close="checkSession" title="Session Expiry")
			p Your session expires soon. Do you want to extend it?
			.actions(slot="actions")
				button.button(@click="logoutSession(true)") No
				button.button.button--primary(@click="checkSession") Yes


		modal(v-if="sessionState === 'expired' && showSessionExpiredModal && !isRefreshingSession" @submit="logoutSession" title="")
			p It seems your session has expired. You will need to sign in again. Redirecting you to the login page...
			.actions(slot="actions")
				button.button.button--primary(@click="logoutSession(true)") Ok
</template>

<script>
import API from "@/api/index";
import Modal from "@/components/Modal";

const DEFAULT_SESSION_TIMEOUT_CHECK_INTERVAL = 60000; // changed ten seconds to 1 minute
const DEFAULT_SESSION_LOW_TIME = 300; // 5 minutes

// These listed here because they do not start with /api/v1/
const GET_SESSION_TIMOEUT_METADATA = "/Session/GetSessionTimeoutMetadata";
const GET_REMAINING_SESSION_TIMEOUT = "/Session/GetRemainingSessionTimeout";
const EXTEND_SESSION = "/Misc/ExtendSession";

export default {
	components: {
		Modal
	},
	props: {
		IsUserIdle: {
			type: Boolean,
			default: true,
			required: true
		}
	},
	data() {
		return {
			isRefreshingSession: false,
			showSessionExpiresSoonModal: true,
			showSessionExpiredModal: true,
			sessionState: "normal",
			interval: null,
			checkIntervalMilliseconds: DEFAULT_SESSION_TIMEOUT_CHECK_INTERVAL,
			lastTimeLeft: null,
			lowTimeSeconds: DEFAULT_SESSION_LOW_TIME,
			sessionWaitTime: 0,
			noOfExtendSession: 0,
			isIdle: false
		};
	},
	watch: {
		IsUserIdle(val, old) {
			if (val !== old) {
				this.isIdle = this.IsUserIdle;
				// this.checkSessionTimeoutRemaining();
			}
		},
		sessionState(val, old) {
			// console.debug("Session State Watcher:", val, old);
			this.isRefreshingSession = false;
			if (val == "expiresSoon" && val !== old)
				this.showSessionExpiresSoonModal = true;
			if (val == "expired" && val !== old) this.showSessionExpiredModal = true;
		},
		interval(_val, old) {
			if (old !== null) clearInterval(old);
		},
		checkIntervalMilliseconds() {
			this.initInterval();
		}
	},
	beforeMount() {
		if (!this.$store.getters.isLoggedIn) {
			return;
		}

		API.getJson(GET_SESSION_TIMOEUT_METADATA)
			.then(json => {
				this.lowTimeSeconds = json.SessionLowTimeSeconds;
				this.checkIntervalMilliseconds = json.SessionTimeoutCheckInterval;
			})
			.catch(err =>
				console.log(
					"Failed to retrieve session timeout metadata. Session may be expired. Error Message:",
					err
				)
			);
	},
	mounted() {
		this.initInterval();
	},
	beforeDestroy() {
		if (this.interval) clearInterval(this.interval);
		if (this.tabinfo) clearInterval(this.tabinfo);
	},
	methods: {
		logoutSession(isValid) {
			this.showSessionExpiresSoonModal = false;
			if (isValid) window.location.href = "/Account/Logout";
			else window.location.href = "/";
		},
		getSessionLowTime(timeleft) {
			this.sessionNormal();
			this.sessionWaitTime =
				timeleft.RemainingSessionTimeoutSeconds - DEFAULT_SESSION_LOW_TIME; //5mins
			this.$emit("ResetTimer");
		},
		checkSession() {
			this.noOfExtendSession += 1;
			this.requestSessionExtension();
		},
		requestSessionExtension() {
			this.isRefreshingSession = true;
			API.get(EXTEND_SESSION)
				.then(() => {
					this.checkSessionTimeoutRemaining();
				})
				.catch(err => {
					console.error("Error extending session:", err);
				});
		},
		initInterval() {
			if (!this.$store.getters.isLoggedIn) {
				window.localStorage.setItem("tabCloseCount", 0);
				this.tabinfo = setInterval(() => {
					if (!window.localStorage.getItem("tabCloseCount"))
						this.sessionState = "expired";
				}, 10000);
			}
			this.interval = setInterval(() => {
				if (!this.$store.getters.isLoggedIn) {
					return;
				}
				this.checkSessionTimeoutRemaining();
			}, this.checkIntervalMilliseconds);
		},
		checkSessionTimeoutRemaining() {
			API.getJson(GET_REMAINING_SESSION_TIMEOUT)
				.then(json => {
					if (json) {
						if (this.isIdle == false) {
							this.getSessionLowTime(json);
						}
						if ("RemainingSessionTimeoutSeconds" in json) {
							const timeleft = json["RemainingSessionTimeoutSeconds"];
							if (timeleft <= 0) {
								this.sessionExpired(timeleft);
							} else if (
								timeleft <= this.sessionWaitTime &&
								this.noOfExtendSession < 4
							) {
								if (
									this.sessionWaitTime - json.RemainingSessionTimeoutSeconds >
									120
								) {
									this.logoutSession(true);
								} else this.sessionExpiresSoon();
							} else if (
								timeleft > this.sessionWaitTime &&
								this.noOfExtendSession >= 4
							) {
								this.sessionNormal();
							}
						} else {
							this.sessionExpired("N/A");
						}
					} else {
						// JSON becomes invalid if session is logged out in any other tab
						this.logoutSession(false);
					}
					console.debug(
						"Remaining Session Timeout Response JSON:",
						json,
						"",
						this.noOfExtendSession
					);
				})
				.catch(err => {
					console.debug(
						"Failed to retrieve session timeout remaining. Session may be expired. Error Message:",
						err
					);
					this.sessionExpired("N/A");
				});
		},
		sessionNormal() {
			this.sessionState = "normal";
			// this.$emit("session:normal", {
			// 	RemainingSessionTimeoutSeconds: timeleft,
			// 	ThreshholdSeconds: this.lowTimeSeconds
			// });
		},
		sessionExpiresSoon() {
			this.sessionState = "expiresSoon";
			// this.$emit("session:expires-soon", {
			// 	RemainingSessionTimeoutSeconds: timeleft,
			// 	ThreshholdSeconds: this.lowTimeSeconds
			// });
			// TODO: show dialog with option to refresh session
		},
		sessionExpired(timeleft) {
			this.sessionState = "expired";
			this.$emit("session:expired", {
				RemainingSessionTimeoutSeconds: timeleft
			});
			// TODO: show dialog?
			// TODO: redirect on dialog confirm OR after 5 seconds
		}
	}
};
</script>

<style lang="stylus"></style>
